import { Search } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLinks } from "../assets/data";
import { colors } from "../theme/theme";

const MobileDrawer = ({ toggleDrawer }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  return (
    <Box
      sx={{ width: 275, backgroundColor: colors.bg, height: "100vh" }}
      role="presentation"
      onClick={toggleDrawer("right", false)}
      onKeyDown={toggleDrawer("right", false)}
    >
      <List>
        <img
          src={require("../assets/icons/logo-sm.png")}
          alt=""
          style={{ height: "80px", width: "220px", margin: "15px" }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: search ? "white" : "#f9f9f9",
            borderRadius: "0px",
            border: search ? "1px double #00000026" : "1px solid #00000026",
            px: 2,
            height: "50px",
            transition: "background-color 0.3s ease",
            mx: 2,
            mb: 2,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <InputBase
            placeholder="Search"
            placeholderTextColor="#00000080"
            sx={{
              fontSize: "14px",
              flex: 1,
            }}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <IconButton onClick={() => navigate(`/search/${search}`)}>
            <Search sx={{ color: "#000" }} />
          </IconButton>
        </Box>

        {NavLinks.map((item) => (
          <ListItem key={item.title}>
            <ListItemButton
              sx={{ padding: 0 }}
              onClick={() => navigate(item.link)}
            >
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{
                  sx: {
                    whiteSpace: "pre-line",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default MobileDrawer;
